export default __webpack_public_path__ + "static/media/sp1.55784544.jpeg";